import ApiCore from './api-core'
import { IDENTIFY } from '@/constants/api-types'

export default class BankAccount extends ApiCore {
  constructor(store) {
    const path = `${IDENTIFY}/financial/bankAccount`
    super(store, path)
  }

  report(filter, showProgress) {
    return this.request({
      action: 'report',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  get(id, showProgress) {
    return this.request({
      action: `${id}`,
      method: 'GET',
      showProgress
    })
  }

  edit(id, model, showProgress) {
    return this.request({
      action: `${id}`,
      method: 'PUT',
      body: model,
      showProgress
    })
  }

  create(model, showProgress) {
    return this.request({
      action: 'create',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  delete(id, showProgress) {
    return this.request({
      action: `${id}`,
      method: 'DELETE',
      showProgress
    })
  }

  list(showProgress) {
    return this.request({
      action: 'list',
      method: 'GET',
      showProgress
    })
  }
}
